// extracted by mini-css-extract-plugin
export default {"root":"styles_root__RqlR5","root_fluid":"styles_root_fluid__tjEbX"};